/**
 * web/src/hooks/queries/usePendingGates.ts
 * Pending gates for one event (server also access-scopes; admin sees all).
 * Powers the Approval Queue and the sidebar Approvals badge (D-2.4).
 * Cache key `['gates','pending',eventId]`; the broad `['gates','pending']`
 * prefix the WS gate invalidate uses (qk.gates.root) left-prefix-matches it.
 */
import { useQuery } from '@tanstack/react-query';
import { fetchPendingGates } from '../../api/gates';
import { qk } from '../../lib/queryKeys';

/**
 * Fetches GET /api/gates/pending?eventId=. Scoped to the dashboard's active
 * event so the queue + badge match the Workflows tab. Disabled until the event
 * resolves (mirrors useWorkflows) so we never flash an all-events queue.
 *
 * @param eventId active event id (from useEvent); undefined disables the query
 * @returns React Query result for PendingGate[]
 * @sideEffects HTTP GET
 * @idempotent yes
 */
export function usePendingGates(eventId?: string) {
  return useQuery({
    queryKey: qk.gates.pending(eventId),
    queryFn: () => fetchPendingGates(eventId),
    enabled: eventId != null,
  });
}
